import { render, staticRenderFns } from "./KedvezmenyekB8.vue?vue&type=template&id=08b1bd2b&"
import script from "./KedvezmenyekB8.vue?vue&type=script&lang=js&"
export * from "./KedvezmenyekB8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports